<div class="dataview"
     style="height: 600px;">
  <div class="summary-container">
    <div class="data-results-summary">
      <span class="results-count">{{totalCount}} {{totalCount === 1 ? 'item' : 'items'}}</span>
      <ng-container *ngIf="selection && hasSelectedRows()">
        <div class="results-selected"
             data-cy="selection-info">
          <div class="datex-text"
               data-cy="selection-info-text">({{ selectedRowsCount }} selected)</div>
          <button (click)="onClearSelectionClicked()"
                  class="datex-button"
                  data-cy="selection-info-clear-button">
            <div class="button-label">
              <div class="button-icon"><i class="icon icon-ic_fluent_dismiss_20_regular"></i></div>
              <div class="button-text"></div>
            </div>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="dataview-tools">
    <ng-content select="[topToolbar]"></ng-content>
  </div>
  <div class="dataview-filters">
    <ng-content select="[filters]"></ng-content>
  </div>

  <div class="dataview-grid styled-grid"
       style="height: 100%">
    <div class="grid-container"
         [ngClass]="containerStyles.classes"
         [ngStyle]="containerStyles.style"
         data-cy="grid"
         style="height: 100%; min-height: 100px;">
      <ag-grid-angular #agGrid
                       class="ag-theme-quartz"
                       style="height: 100%;"
                       [columnDefs]="agColDefs"
                       [rowSelection]="agSelection"
                       [pagination]="false"
                       [paginationPageSize]="pageSize"
                       [cacheBlockSize]="pageSize"
                       [maxBlocksInCache]="0"
                       [rowData]="rows"
                       [getRowId]="getRowId"
                       editType="fullRow"
                       [suppressClickEdit]="true"
                       [suppressDragLeaveHidesColumns]="true"
                       [paginationPageSizeSelector]="false"
                       (selectionChanged)="onSelectionChanged($event)"
                       (rowEditingStopped)="onRowEditingStopped($event)"
                       (rowEditingStarted)="onRowEditingStarted($event)"
                       [statusBar]="statusBar"
                       [masterDetail]="rowCanExpand"
                       [detailCellRenderer]="detailCellRenderer"
                       [detailCellRendererParams]="detailCellRendererParams"
                       (cellKeyDown)="onCellKeyDown($event)"
                       [autoSizeStrategy]="containerStyles.autoSizeStrategy"
                       (gridReady)="onAgGridReady($event)" />
    </div>
  </div>

</div>